import ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'
import { TokenService } from '../../services/storage.service';

const state = {
    categories: [],
    groupCategories: [],
    userDetails: TokenService.getUserDetails(),
    applicationFilePath: '',
    stockListPath: '',
    priceListPath: '',
    loading: false,
    exportLoading: false,
    newsLoading: false,
    latestNews: [],
    articlesLoading: false,
    latestArticles: [],
}

const getters = {
    getCategories : (state) => {
        return state.categories;
    },
    getGroupCategories : (state) => {
        return state.groupCategories;
    },
    fetchUserDetails : (state) => {
        return state.userDetails;
    },
    applicationFilePath: (state) => (state.applicationFilePath),
    setStockListPath: (state) => (state.stockListPath),
    setPriceListPath: (state) => (state.priceListPath),
    loading: state => state.loading,
    exportLoading: state => state.exportLoading,
    newsLoading: state => state.newsLoading,
    articlesLoading: state => state.articlesLoading,
    getLatestNews: (state) => {
        return state.latestNews;    
    },
    getLatestArticles: (state) => {
        return state.latestArticles;    
    }
}

const actions = {
    fetchGroupCategories({commit}, lang) {
        commit('setLoading', true)
        let params = { lang: HashMake.encrypt(lang) };

        ApiService.post('group-categories', params).then((response) => {
            commit('setGroupCategories', response.data.data)
        }).finally(() => {
            commit('setLoading', false)
        })
    },
    fetchCategories({commit}, lang) {
        commit('setLoading', true)
        let params = { lang: HashMake.encrypt(lang) };

        ApiService.post('categories', params).then((response) => {
            commit('setCategories', response.data.data)
        }).finally(() => {
            commit('setLoading', false)
        })
    },
    fetchPriceListData({commit}, items) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setExportLoading', true)

            let params = {};
            if(items.groupName){
                params = { 'bookingNo': HashMake.encrypt(items.groupName), 'listType': HashMake.encrypt(items.priceListType) };
            } else {
                params = { 'listType': HashMake.encrypt(items.priceListType) };
            }
            
            ApiService.post('price-list/export', params)
            .then(response => {
                commit('setPriceListPath', response.data.message)

                const link = document.createElement('a');
                link.href = response.data.message;
                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();

                resolve()
            })
            .finally(() => {
                commit('setLoading', false)
                commit('setExportLoading', false)
            })
        })
    },
    fetchStockListData({commit}, groupName='') {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setExportLoading', true)
            let params = {};
            if(groupName){
                params = { bookingNo: HashMake.encrypt(groupName) };
            }
            ApiService.post('stock-list/export', params)
            .then(response => {
                commit('setStockListPath', response.data.message)

                const link = document.createElement('a');
                link.href = response.data.message;
                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();
                
                resolve()
            })
            .finally(() => {
                commit('setLoading', false)
                commit('setExportLoading', false)
            })
        })
    },
    fetchApplicationListData({ commit }, categoryId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setExportLoading', true)
            let params = { categoryID: HashMake.encrypt(categoryId) };

            ApiService.post('application-list/export', params)
                .then(response => {
                    commit('setApplicationFilePath', response.data.message)

                    const link = document.createElement('a');
                    link.href = response.data.message;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                    
                    resolve()
                })
                .catch(error => {
                    return reject({ 'data': error.response.data })
                })
                .finally(() => {
                    commit('setLoading', false)
                    commit('setExportLoading', false)
                })
        });
    },

    fetchLatestNews({commit}) {
        return new Promise((resolve, reject) => {
            commit('setNewsLoading', true)
            let params = { 'baseUrl': HashMake.encrypt(process.env.VUE_APP_BASE_URL) };
            
            ApiService.get('get-latest-news')
            .then((response) => {
                commit('setLatestNews', response.data.data)
                resolve()
            })
            .finally(() => {
                commit('setNewsLoading', false)
            })
        })
    },
    
    fetchLatestArticles({commit}) {
        return new Promise((resolve, reject) => {
            commit('setArticlesLoading', true)

            ApiService.get('get-latest-articles')
            .then((response) => {
                commit('setLatestArticles', response.data.data)
                resolve()
            })
            .finally(() => {
                commit('setArticlesLoading', false)
            })
        })
    },
}

const mutations = {
    setCategories(state, data){
        state.categories = data
    },
    setGroupCategories(state, data) {
        state.groupCategories = data
    },
    setApplicationFilePath(state, val) {
        state.applicationFilePath = val
    },
    setStockListPath(state, val) {
        state.stockListPath = val
    },
    setPriceListPath(state, val) {
        state.priceListPath = val
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setExportLoading(state, loadingExport) {
        state.exportLoading = loadingExport
    },
    setNewsLoading(state, loading) {
        state.newsLoading = loading
    },
    setLatestNews(state, data) {
        state.latestNews = data
    },
    setArticlesLoading(state, loading) {
        state.articlesLoading = loading
    },
    setLatestArticles(state, data) {
        state.latestArticles = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}